export default {
    data () {
        return {
            swiperOptions: {
                autoplay: true,
                pagination: {
                    el: '.swiper-pagination',
                    bulletActiveClass: 'swiper-pagination-bullet-active',
                    clickable :true,
                },
                navigation: {
                    nextEl: '.carousel-next',
                    prevEl: '.carousel-prev',
                }
            }
        }
    }
}